import { scorePasswordStrength } from "../../../utils/functions";
import { PW_STRENGTH_LEVELS } from "../Client/MyProfile/data";
import styles from "./PasswordStrengthMeter.module.css";

export default function PasswordStrengthMeter({ value }) {
  const score = scorePasswordStrength(value);
  const level = PW_STRENGTH_LEVELS[score];

  return (
    <>
      <div className={styles.bar}>
        <div
          className={styles.fill}
          style={{ width: level.width, background: level.colour }}
        />
      </div>
      <div className={styles.hint} style={{ color: level.colour }}>
        {level.label}
      </div>
    </>
  );
}
